import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Routers from './Routes/route';
import { Toaster } from 'react-hot-toast';

const root = ReactDOM.createRoot(document.getElementById('root'));
console.log = console.warn = console.error = console.info = console.debug = () => {};

root.render(
  <Router>
    <Toaster />
    <Routers />
  </Router>
);

reportWebVitals();